export function downloadBlob(blob, filename) {
  if (!filename) {
    throw Error("Missing parameter: " + filename);
  }
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const a = window.document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    // window.URL.revokeObjectURL(url);
    setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }, 100);
  }
}

export function prettyPrintXml(input, indent) {
  indent = indent || '\t'; //you can set/define other ident than tabs

  //PART 1: Add \n where necessary
  let xmlString = input.replace(/^\s+|\s+$/g, '');  //trim it (just in case) {method trim() not working in IE8}

  xmlString = input
      .replace( /(<([a-zA-Z]+\b)[^>]*>)(?!<\/\2>|[\w\s])/g, "$1\n" ) //add \n after tag if not followed by the closing tag of pair or text node
      .replace( /(<\/[a-zA-Z]+[^>]*>)/g, "$1\n") //add \n after closing tag
      .replace( />\s+(.+?)\s+<(?!\/)/g, ">\n$1\n<") //add \n between sets of angled brackets and text node between them
      .replace( />(.+?)<([a-zA-Z])/g, ">\n$1\n<$2") //add \n between angled brackets and text node between them
      .replace(/\?></, "?>\n<") //detect a header of XML

  let xmlArr = xmlString.split('\n');  //split it into an array (for analise each line separately)

  //PART 2: indent each line appropriately

  let tabs = '';  //store the current indentation
  let start = 0;  //starting line

  if (/^<[?]xml/.test(xmlArr[0]))  start++;  //if the first line is a header, ignore it

  for (var i = start; i < xmlArr.length; i++) { //for each line
    var line = xmlArr[i].replace(/^\s+|\s+$/g, '');  //trim it (just in case)

    if (/^<[/]/.test(line)) { //if the line is a closing tag
      tabs = tabs.replace(indent, '');  //remove one indent from the store
      xmlArr[i] = tabs + line;  //add the tabs at the beginning of the line
    } else if (/<.*>.*<\/.*>|<.*[^>]\/>/.test(line)) { //if the line contains an entire node
      //leave the store as is
      xmlArr[i] = tabs + line; //add the tabs at the beginning of the line
    } else if (/<.*>/.test(line)) {//if the line starts with an opening tag and does not contain an entire node
      xmlArr[i] = tabs + line;  //add the tabs at the beginning of the line
      tabs += indent;  //and add one indent to the store
    } else { //if the line contain a text node
      xmlArr[i] = tabs + line;  // add the tabs at the beginning of the line
    }
  }

  //PART 3: return formatted string (source)
  return xmlArr.join('\n');  //rejoin the array to a string and return it
}

export function downloadSvg(svgHtmlElement) {
  // get svg element.
  const svg = svgHtmlElement; //this.$refs.svg;

  // get svg source.
  const serializer = new XMLSerializer();
  let source = serializer.serializeToString(svg);

  // add name spaces.
  if(!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)){
      source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
  }
  if(!source.match(/^<svg[^>]+"http:\/\/www\.w3\.org\/1999\/xlink"/)){
      source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
  }

  source = source.replace(/<(.*?)children="\[.*?\]"/g, "<$1");

  // add xml declaration
  source = '<?xml version="1.0" standalone="no"?>\r\n' + source;

  // console.log(prettyPrintXml(source));

  const filename = 'image.svg';
  const blob = new Blob([source], { type: 'text/plain' });
  downloadBlob(blob, filename);
}

/**
 * Trova il nodo di tipo 'nodeName' che, nel percorso a ritroso da
 * 'innerElement' ad 'outerElement', risulta più vicino ad outerElement.
 * Se non viene trovato l'elemento cercato, ritorna 'innerElement'.
 */
export function findTarget(innerElement, outerElement, nodeName) {
  const path = elementPath(innerElement, outerElement);
  let target = innerElement;
  for (let i = path.length - 1; i >= 0; i--) {
    if (path[i].nodeName === nodeName) {
      target = path[i];
      break;
    }
  }
  return target;
}

/**
 * Trova (nell'albero radicato in component) il primo componente Vue c
 * per cui filter(c) ritorna true
 */
export function findComponent(rootComponent, filter) {
  if (filter(rootComponent)) {
    return rootComponent;
  }

  const children = rootComponent.$children;
  for (let i = 0; i < children.length; i++) {
    const found = findComponent(children[i], filter);
    if (found) {
      return found;
    }
  }

  return undefined;
}

export function elementPath(element, last) {
  var ret = [];
  while (element) {
    ret.push(element);
    if (typeof last === 'string' && element.nodeName === last) {
      return ret;
    } else if (element === last) {
      return ret;
    }
    element = element.parentElement;
  }
  if (ret.indexOf(window) === -1 && ret.indexOf(document) === -1) {
    ret.push(document);
  }
  if (ret.indexOf(window) === -1) {
    ret.push(window);
  }
  return ret;
}
